import { Component, Prop, Vue } from 'vue-property-decorator';
import { TimerId, ComponentProps } from './types';

@Component
export default class ComponentsPartsSliderRotatorMixin extends Vue
  implements ComponentProps {
  // props
  @Prop({ type: Array, required: true })
  items: Array<any>;

  // data
  timer: TimerId = {
    interval: null,
    timeout: null,
  };
  curr: number = -1;
  interval: number = 5;
  timeout: number = 50;

  // Hooks
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  }

  beforeDestroy() {
    this.clearAll();
  }

  // methods
  click(index: number | string) {
    const slLength = this.items.length - 1;

    if (typeof index === 'number') {
      this.curr = index;
    }

    if (index === 'back') {
      if (this.curr > 0) {
        this.curr = --this.curr;
        return;
      }

      if (this.curr === 0) {
        this.curr = slLength;
      }
    }

    if (index === 'forward') {
      if (this.curr < slLength) {
        this.curr = ++this.curr;
        return;
      }

      if (this.curr === slLength) {
        this.curr = 0;
      }
    }

    this.stop();
  }

  stop() {
    this.clearAll();
    this.timer.timeout = window.setTimeout(() => {
      this.start();
    }, (this.timeout - this.interval) * 1000);
  }

  init() {
    this.curr = 0;
    this.start();
  }

  start() {
    if (this.items && this.items.length > 1) {
      this.clearAll();
      this.timer.interval = window.setInterval(() => {
        let next = this.curr + 1;
        this.curr = next < this.items.length ? next : 0;
      }, this.interval * 1000);
    }
  }

  clearInterval() {
    if (this.timer.interval) {
      clearInterval(this.timer.interval);
    }
    this.timer.interval = null;
  }

  clearTimeout() {
    if (this.timer.timeout) {
      clearTimeout(this.timer.timeout);
    }
    this.timer.timeout = null;
  }

  clearAll() {
    this.clearInterval();
    this.clearTimeout();
  }
}



// WEBPACK FOOTER //
// ./src/components/parts/slider/mixin/index.ts